import {
  Directive,
  inject,
  input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { Permission } from '../../types/permission.type';
import { UserService } from '../../user/user.service';

@Directive({
  selector: '[permission]',
  standalone: true,
})
export class PermissionDirective implements OnInit, OnDestroy {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private userService = inject(UserService);

  permission = input.required<Permission>();

  private subscription = new Subscription();
  private hasView = false;

  ngOnInit(): void {
    this.updateView();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private updateView(): void {
    const hasPermission = this.checkPermissions();

    if (hasPermission && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
  }

  private checkPermissions(): boolean {
    return this.userService.checkHasPermission(this.permission());
  }
}
